import FAQ from './FAQ';

export default FAQ
export { FAQ as Base }
